import React, { useEffect, useState } from 'react';
import { Input, Label, Select } from '../../Shared';
import axios from 'axios';
import { useAppContext } from '../../context/AppContext';
import { Collapse } from 'react-collapse';
import Modal from '../../modals/Modal';
import PermitForm from '../permits/PermitForm';
import MailOwner from '../permits/MailOwner';
import MailProvider from '../permits/MailProvider';
import AddProduct from '../products/AddProduct';
import CalcForm from '../products/CalForm';
import { useJobContext } from '../../context/JobContext';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Mapper from '../Mapper';
import Addons from './Addons';
import PDF from './PDF';
import { useParams } from 'react-router-dom';


const NewJob = () => {
  const [permits, setPermits] = useState([]);
  const [permit, setPermit] = useState([]);
  const [owners, setOwners] = useState([]);
  const [owner, setOwner] = useState([]);
  const [provider, setProvider] = useState([]);
  const [mailProviders, setMailProviders] = useState([]);
  const [products, setProducts] = useState([]);
  const [showMachineablePopup, setShowMachineablePopup] = useState(false);
  const [promotionsEnabled, setPromotionsEnabled] = useState(false);
  const [mailTrackingEnabled, setMailTrackingEnabled] = useState(false);
  const [postOffice, setPostOffice] = useState('');
  const [customJobId, setCustomJobId] = useState('');
  const [isOpened, setIsOpened] = useState(false);
  const [permitOpen, setPermitOpen] = useState(false);
  const [ownerOpen, setOwnerOpen] = useState(false);
  const [providerOpen, setProviderOpen] = useState(false);
  const [productOpen, setProductOpen] = useState(false);
  const [calcOpen, setCalcOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const { axiUrl } = useAppContext();
  const { formData, setFormData, getjson } = useJobContext();

  const company = useParams()

  useEffect(() => {
    const getperms = async () => {
      await axios
        .post(`${axiUrl}/permits/getpermitholder`, { id:company.id })
        .then((res) => setPermits(res.data));
    };
    const getowners = async () => {
      await axios
        .post(`${axiUrl}/permits/getmailowners`, { id:company.id })
        .then((res) => {
          console.log(res.data)
          setOwners(res.data)
    });
    };
    const getproviders = async () => {
      await axios
        .post(`${axiUrl}/permits/getmailproviders`, { id:company.id })
        .then((res) => {
          console.log(res.data);
          setMailProviders(res.data);
        });
    };
    const getproducts = async () => {
      await axios
        .post(`${axiUrl}/products/getproducts`, { id:company.id })
        .then((res) => {
          console.log(res.data);
          setProducts(res.data.products);
        });
    };
   
    getproducts();
    getproviders();
    getperms();
    getowners();
   
  }, [reset]);

  const basePromotions = [
    'Integrated Technology (IT)',
    'Tactile Sensory Interactive (SS)',
    'Advertising with First Class',
    'Continuous Contact',
    'Catalog Promotion',
  ];

  const addOns = ['Informed Delivery', 'Sustainability'];

  const temppermit = (e) => {
    let perm;
    let selectedpermit = permits.filter((filt) => filt._id === e.target.value);
    let permitinfo = selectedpermit[0];
    console.log(permitinfo);
    switch (selectedpermit[0].permitType) {
      case 'Indicia':
      case 'Permit':
        perm = 'IndiciaPermit';
        break;
      case 'Stamp':
        perm = 'PrecanceledStamp';
        break;
      default:
        perm = null;
        break;
    }
    setFormData({
      ...formData,
      paymentMethod: perm,
      permitAccountNumber: permitinfo.accountNumber,
      permitAddress: permitinfo.address,
      permitAddress2: permitinfo.address2,
      permitBmeu: permitinfo.bmeu,
      permitCity: permitinfo.city,
      permitCompanyName: permitinfo.companyName,
      permitDueNetNumber: permitinfo.dueNetNumber,
      permitName: permitinfo.permitName,
      permitNumber: permitinfo.permitNumber,
      permitType: permitinfo.permitType,
      permitState: permitinfo.state,
      permitZip: permitinfo.zip,
      permitId: permitinfo._id,
    });
  };

  const tempowner = (e) => {
   let selectedpermit = owners.filter((filt) => filt._id === e.target.value);
   let owner = selectedpermit[0];
    setFormData({
      ...formData,
      ownerAddress: owner.address,
      ownerAddress2: owner.address2,
      ownerCity: owner.city,
      ownerState: owner.state,
      ownerZip: owner.zip,
      ownerCompanyName: owner.companyName,
      ownerCrid: owner.crid,
      ownerMid: owner.mid,
      ownerNonprofitnumber: owner.nonprofitnumber,
      ownertemplate: owner.template,
      ownerId: owner._id,
    });
  };

  const tempprovider = (e) => {
    let selectedpermit = mailProviders.filter((filt) => filt._id === e.target.value);
    let provider = selectedpermit[0];
    console.log(provider);
    setFormData({
      ...formData,
      providerAddress: provider.address,
      providerAddress2: provider.address2,
      providerCity: provider.city,
      providerState: provider.state,
      providerZip: provider.zip,
      providerName: provider.providerName,
      providerCrid: provider.crid,
      providerMid: provider.mid,
      providerEinduction: provider.einduction,
      providerRepemail: provider.repemail,
      providerRepname: provider.repname,
      providerRepphone: provider.repphone,
      providerSeamless: provider.seamless,
      providerId: provider._id,
    });
  };

  const tempproduct = (e) => {
    let selectedproducts = products.filter((filt) => filt._id === e.target.value);
    let product = selectedproducts[0];
    console.log(product);
    setFormData({
      ...formData,
      productLength: product.length,
      productMachinable: product.machinable,
      productName: product.name,
      productPaperType: product.paperType,
      productSku: product.sku,
      productThickness: product.thickness,
      productWeight: product.weight,
      productweightType: product.weightType,
      productweightUnit: product.weightUnit,
      productWidth: product.width,
      productId: product._id,
    });
  };

  const gotonext = async (e) => {
    e.preventDefault();
    await getjson(formData, company?.id);
    setSelectedTab((prev) => Math.min(prev + 1, 2));
  };

  const goToNextTab = () => {
    setSelectedTab((prev) => Math.min(prev + 1, 2));
  };

  console.log(formData);

  return (
    <>
      <Modal show={permitOpen} onClose={() => setPermitOpen(false)}>
        <PermitForm company={company?.id} setPermit={setPermit} setReset={setReset} reset={reset} onClose={() => setPermitOpen(false)} />
      </Modal>
      <Modal show={ownerOpen} onClose={() => setOwnerOpen(false)}>
        <MailOwner company={company?.id} setPermit={setOwner} setReset={setReset} reset={reset} onClose={() => setOwnerOpen(false)} />
      </Modal>
      <Modal show={providerOpen} onClose={() => setProviderOpen(false)}>
        <MailProvider company={company?.id} setPermit={setProvider} setReset={setReset} reset={reset} onClose={() => setProviderOpen(false)} />
      </Modal>
      <Modal show={productOpen} onClose={() => setProductOpen(false)}>
        <AddProduct company={company?.id} setProduct={setPermit} setCalcOpen={setCalcOpen} setReset={setReset} reset={reset} onClose={() => setProductOpen(false)} />
      </Modal>
      <Modal show={calcOpen} onClose={() => setCalcOpen(false)}>
        <CalcForm onClose={() => setCalcOpen(false)} />
      </Modal>
      <form onSubmit={gotonext}>
        <div className="min-h-screen bg-gray-200 p-4">
          <Tabs selectedIndex={selectedTab} onSelect={(index) => setSelectedTab(index)} forceRenderTabPanel={true}>
            <TabList>
              <Tab>Job Details</Tab>
              <Tab>Job Files</Tab>
              <Tab>Job Review</Tab>
            </TabList>
            <TabPanel>
              <div className="bg-white shadow-md rounded-lg p-6">
                <div className="mb-6">
                  Job Description\Job Title<br />
                  <Input
                    type=""
                    value={formData?.jobDescription}
                    onChange={(e) => setFormData({ ...formData, jobDescription: e.target.value })}
                    required
                  />
                </div>
                <div className="relative p-3 border border-gray-400 mt-3 pb-6">
                  <div className="flex relative">
                    <div className="flex-1 p-2">
                      <div className="flex">
                        <div>Permit Setup</div>
                        <div className="ml-auto">
                          <button
                            type="button"
                            className="bg-[#4f46e5] text-white px-2 py-1 rounded hover:bg-white text-[10px] hover:border-1 hover:text-[#4f46e5] hover:font-bold  mb-2 hover: cursor-pointer "
                            onClick={() => setPermitOpen(true)}
                          >
                            New Permit Setup
                          </button>
                        </div>
                      </div>
                      <Select onChange={temppermit} value={formData?.permitId} required>
                        <option value="" selected disabled>
                          Select Permit Setup
                        </option>
                        {permits.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.permitName}
                          </option>
                        ))}
                      </Select>
                    </div>
                    <div className="flex-1 p-2">
                      <div className="flex">
                        <div>Mail Owner</div>
                        <div className="ml-auto">
                          <button
                            type="button"
                            className="bg-[#4f46e5] text-white px-2 py-1 rounded hover:bg-white text-[10px] hover:border-1 hover:text-[#4f46e5] hover:font-bold  mb-2 hover: cursor-pointer "
                            onClick={() => setOwnerOpen(true)}
                          >
                            New Mail Owner
                          </button>
                        </div>
                      </div>
                      <Select onChange={tempowner} value={formData?.ownerId} required>
                        <option value="" selected disabled>
                          Select Mail Owner
                        </option>
                        {owners.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.companyName}
                          </option>
                        ))}
                      </Select>
                    </div>
                    <div className="flex-1 p-2">
                      <div className="flex">
                        <div>Mail Provider</div>
                        <div className="ml-auto">
                          <button
                            type="button"
                            className="bg-[#4f46e5] text-white px-2 py-1 rounded hover:bg-white text-[10px] hover:border-1 hover:text-[#4f46e5] hover:font-bold  mb-2 hover: cursor-pointer "
                            onClick={() => setProviderOpen(true)}
                          >
                            New Mail Provider
                          </button>
                        </div>
                      </div>
                      <Select onChange={tempprovider} value={formData?.providerId} required>
                        <option value="" selected disabled>
                          Select Mail Provider
                        </option>
                        {mailProviders.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.providerName}
                          </option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="mt-6 flex gap-4 box-border ">
                  <div className="w-full flex-1 lg:w-1/3 px-2">
                    <div className="flex">
                      <div>Product</div>
                      <div className="ml-auto">
                        <button
                          type="button"
                          className="bg-[#4f46e5] text-white px-2 py-1 rounded hover:bg-white text-[10px] hover:border-1 hover:text-[#4f46e5] hover:font-bold  mb-2 hover: cursor-pointer "
                          onClick={() => setProductOpen(true)}
                        >
                          New Product
                        </button>
                      </div>
                    </div>
                    <Select onChange={tempproduct} value={formData?.productId} required>
                      <option value="" selected disabled>
                        Select Mail Product
                      </option>
                      {products?.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name} {item.paperType}
                        </option>
                      ))}
                    </Select>
                  </div>
                  <div className="w-full flex-1 px-2">
                    <Label>Mail Class</Label>
                    <Select
                      value={formData?.mailClass}
                      onChange={(e) => setFormData({ ...formData, mailClass: e.target.value })}
                      required
                    >
                      <option value="" selected disabled>
                        Select Class
                      </option>
                      <option value="First">First</option>
                      <option value="Nonprofit">Nonprofit</option>
                      <option value="Standard">Standard</option>
                    </Select>
                  </div>
                  <div className="w-full flex-1 lg:w-1/3 px-2">
                    <Label>Post Office of Entry</Label>
                    <Select
                      value={formData?.postOffice}
                      onChange={(e) => setFormData({ ...formData, postOffice: e.target.value, postofficename: e.target.options[e.target.selectedIndex].text })}
                      required
                    >
                      <option value="" selected disabled>
                        Select Post Office
                      </option>
                      <option value="BMEU">BMEU of Permit</option>
                      {permits.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.permitName}
                        </option>
                      ))}
                      <option value="Other">Other</option>
                    </Select>
                    {postOffice === 'Other' && <Input type="text" placeholder="Enter BMEU" className="mt-2" />}
                  </div>
                </div>
                <div className="flex flex-wrap gap-4 mt-4">
                  <div className="w-full flex-1 px-2">
                    <Label>Pay Method</Label>
                    <Select value={formData?.paymentMethod} disabled required>
                      <option value="" selected disabled>
                        Select Pay Method
                      </option>
                      <option value="IndiciaPermit">Indicia/Permit</option>
                      <option value="PrecanceledStamp">Precanceled Stamp</option>
                    </Select>
                  </div>
                  <div className="w-full flex-[.5] px-2">
                    <Label>Mail Date</Label>
                    <Input
                      type="date"
                      value={formData?.mailDate}
                      onChange={(e) => setFormData({ ...formData, mailDate: e.target.value })}
                      required
                    />
                  </div>
                  <div className="w-full flex-1 px-2 flex items-center gap-4">
                    <div className="items-center mt-5 w-full">
                      <div className='flex'>
                        <input
                          type="checkbox"
                          id="dropship"
                          className="mr-2"
                          checked={formData?.dropship}
                          onClick={(e) => setFormData({ ...formData, dropship: e.target.checked })}
                        />
                        <Label className="mt-2" htmlFor="dropship">
                          Drop Shipping
                        </Label>
                      </div>
                      {formData?.dropship && (
                        <div>
                          <Input
                            type="text"
                            placeholder="Enter Drop Ship Company"
                            className=""
                            value={formData?.dropshipname}
                            onChange={(e) => setFormData({ ...formData, dropshipname: e.target.value })}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex items-center mt-6 pl-4 gap-4 w-full items-start">
                  <Label>Promotions</Label>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="promotionsYes"
                      name="promotions"
                      onChange={() => setFormData({ ...formData, promotions: 'Yes' })}
                      className="mr-1"
                    />
                    <Label htmlFor="promotionsYes">Yes</Label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="promotionsNo"
                      name="promotions"
                      defaultChecked
                      onChange={() => setFormData({ ...formData, promotions: 'No' })}
                      className="mr-1"
                    />
                    <Label htmlFor="promotionsNo">No</Label>
                  </div>
                  {formData.promotions === 'Yes' && (
                    <>
                      <div className="flex-1">
                        <Label>Base Promotion</Label>
                        <Select value={formData.basepromotions} onChange={(e) => setFormData({ ...formData, basepromotions: e.target.value })}>
                          <option value="" selected disabled>
                            Select Base Promotion
                          </option>
                          {basePromotions.map((promo, index) => (
                            <option key={index} value={promo}>
                              {promo}
                            </option>
                          ))}
                        </Select>
                      </div>
                   <div className="flex-1">
  <Label>Add-Ons </Label>
  <div className="mt-2 space-y-2">
  
    <div className="flex items-center">
  <input
    type="checkbox"
    id="addon1"
    checked={formData?.addon1 === "Informed Delivery"}
    className="h-4 w-4 text-blue-600 border-gray-300 rounded"
    onChange={(e) => setFormData({ ...formData, addon1: e.target.checked ? "Informed Delivery" : "" })}
  />
  <label htmlFor="addon1" className="ml-2 text-sm text-gray-700">
    Informed Delivery
  </label>
</div>
    <div className="flex items-center">
  <input
    type="checkbox"
    id="addon2"
    checked={formData?.addon2 === "Sustainability"}
    className="h-4 w-4 text-blue-600 border-gray-300 rounded"
    onChange={(e) => setFormData({ ...formData, addon2: e.target.checked ? "Sustainability" : "" })}
  />
  <label htmlFor="addon2" className="ml-2 text-sm text-gray-700">
 Sustainability
  </label>
</div>
  </div>
</div>
                    </>
                  )}
                </div>
                <div className="mt-4 border-t pt-4">
                  <div className="flex whitespace-nowrap">
                    <h3 className="text-lg font-semibold mb-2 mr-4">Advanced Options</h3>
                    <svg
                      onClick={() => setIsOpened(!isOpened)}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="size-5"
                    >
                      <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                      <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
                    </svg>
                  </div>
                  <Collapse isOpened={isOpened}>
                    <div className="flex gap-2">
                      <div className="flex flex-[.7] items-center">
                        <input
                          type="checkbox"
                          id="no1Trays"
                          className="mr-2 -mt-2"
                          onChange={(e) => setFormData({ ...formData, no1Trays: e.target.checked })}
                          checked={formData.no1Trays}
                        />
                        <Label htmlFor="no1Trays">No 1' Trays (MM or EMM)</Label>
                      </div>
                      <div className="block flex flex-1 items-center">
                        <input
                          type="checkbox"
                          id="growthIncentive"
                          className="mr-2 -mt-2"
                          onChange={(e) => setFormData({ ...formData, growthIncentive: e.target.checked })}
                          checked={formData.growthIncentive}
                        />
                        <Label className="" htmlFor="growthIncentive">
                          Growth Incentive Credit Redemption
                        </Label>
                      </div>
                      <div className="flex flex-[.5] items-center">
                        <input
                          type="checkbox"
                          id="ballotballotboxMail"
                          className="mr-2 -mt-2"
                          onChange={(e) => setFormData({ ...formData, ballotbox: e.target.checked })}
                          checked={formData.ballotbox}
                        />
                        <Label htmlFor="ballotMail">Ballot Mail</Label>
                      </div>
                        <div className="flex flex-[.5] items-center">
                        <input
                          type="checkbox"
                          id="political"
                          className="mr-2 -mt-2"
                          onChange={(e) => setFormData({ ...formData, political: e.target.checked })}
                          checked={formData.political}
                        />
                        <Label htmlFor="political">Political Mail</Label>
                      </div>
                        <div className="flex flex-[.5] items-center">
                        <input
                          type="checkbox"
                          id="IMbarcode"
                          className="mr-2 -mt-2"
                          onChange={(e) => setFormData({ ...formData, IMbarcode: e.target.checked })}
                          checked={formData.IMbarcode}
                        />
                        <Label htmlFor="IMbarcode">IM Barcode</Label>
                      </div>
                       <div className="flex flex-[.5] items-center">
                        <input
                          type="checkbox"
                          id="unevenThickness"
                          className="mr-2 -mt-2"
                          onChange={(e) => setFormData({ ...formData, unevenThickness: e.target.checked })}
                          checked={formData.unevenThickness}
                        />
                        <Label htmlFor="unevenThickness">Uneven Thickness</Label>
                      </div>
                    </div>

                    <div className="flex items-center gap-4">
                      <div className="flex-1">
                        <Label htmlFor="smallPallets">Small Pallets</Label>
                        <Select id="smallPallets">
                          <option value="" selected disabled>
                            Select Option
                          </option>
                          <option value="none">None</option>
                          <option value="letters">Letters & Postcards (Min 6' per Pallet)</option>
                          <option value="flats">Flats (Min 100 lbs, Max 800 lbs)</option>
                        </Select>
                      </div>
                      <div className="flex-1">
                        <Label htmlFor="tallPallets">Tall Pallets</Label>
                        <Select id="tallPallets">
                          <option value="" selected disabled>
                            Select Option
                          </option>
                          <option value="none">None</option>
                          <option value="emm">EMM (Max 96")</option>
                          <option value="mm">MM (Max 120")</option>
                        </Select>
                      </div>
                      <div className="flex-1">
                        <Label htmlFor="customJobId">Job ID</Label>
                        <Input
                          type="text"
                          id="uspsJobId"
                          placeholder="Enter USPS Job ID"
                          maxLength="8"
                          value={formData?.uspsJobId}
                          onChange={(e) => setFormData({ ...formData, uspsJobId: e.target.value })}
                        />
                      </div>
                    </div>
                  </Collapse>
                </div>
                <div className="mt-4 flex justify-end">
                  <button type="submit" className="bg-[#4f46e5] text-white  hover:bg-white  hover:border-1 hover:text-[#4f46e5] hover:font-bold  mb-2 hover: cursor-pointer  px-6 py-1 rounded">
                    {`Next ->`}
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <Mapper goToNextTab={goToNextTab} />
            </TabPanel>
            <TabPanel>
              <PDF company={company?.id} />
            </TabPanel>
          </Tabs>
        </div>
      </form>
    </>
  );
};

export default NewJob;